import React, { Component } from "react";
import ReactApexChart from "react-apexcharts";

class ApexPie extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            series: props.data,
            options: {
                chart: {
                    // height: 350,
                    type: "donut",
                    offsetY: -10,
                    // toolbar: {
                    //    show: false,
                    // },
                },
                labels: props.labels,
                colors: props.colors,
                stroke: {
                    width: [0],
                },
                legend: {
                    position: "top",
                    offsetX: -10,
                },
                dataLabels: {
                    enabled: false,
                },
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            chart: {
                                // width: 100,
                            },
                        },
                    },
                ],
            },
        };
    }

    render() {
        return (
            <div
                id="chart"
                className="text-center m-auto"
                style={{ width: this.props.width ? `${this.props.width}%` : "80%" }}
            >
                <ReactApexChart
                    options={this.state.options}
                    series={this.state.series}
                    type="donut"
                    height={this.props.height ? 250 : 250}
                    width={'100%'}
                />
            </div>
        );
    }
}

export default ApexPie;
